import { z } from "zod";

export const manualOrderSchema = z.object({
	invoiceNumber: z.string(),
	productSelection: z.array(
		z.object({
			productId: z.string(),
			title: z.string().optional(),
			amount: z.number().default(1),
			price: z.object({
				netPrice: z.number().default(0),
				grossPrice: z.number().default(0),
				taxRatePercentage: z.number().default(0),
			}),
		}),
	),
	discountSelection: z.array(z.string()),
	forAccountId: z.string(),
});
